module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f6af8ce94d2a2019c213cf2c0df908b4.png";